
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;

  var C = {
    logo:      { component_id: 'header_logo',                placement: 'header_left' },
    nav:       { component_id: 'header_nav',                 placement: 'header_primary' },
    search:    { component_id: 'header_search',              placement: 'header_right' },
    suggest:   { component_id: 'search_suggestions',         placement: 'search_drawer' },
    suggestPd: { component_id: 'search_product_suggestions', placement: 'search_drawer' },
    siteSearch:{ component_id: 'site_search',                placement: 'search_drawer' },
    results:   { component_id: 'search_results',             placement: 'search_results' },
    resultGrid:{ component_id: 'search_results_grid',        placement: 'search_results' },
    account:   { component_id: 'header_account',             placement: 'header_right' },
    cart:      { component_id: 'header_cart',                placement: 'header_right' }
  };

  var SEL = {
    logo:        'a.header-logo',
    
    navRootLink: 'a.tmenu_item_link, a.header-menu-link',
    navLink:     'a.tmenu_item_link, a.header-menu-link, .mega-menu-container a, .mega-menu-item a',
    navText:     'span.tmenu_item_text',
    navSubmenu:  'ul[class*="tmenu_submenu"], .mega-menu-wrapper, .mega-menu-container',
    navItem:     'li.tmenu_item--root, li.header-menu-item',
    mobileLink:  '[mobile-drawer-content] a, .mobile-menu-submenu a, mobile-menu a',
    searchPopup: '#glFilter-search-popup',
    searchInput: '#gl-d-searchbox-input',
    searchForm:  '.gl-d-searchbox, form[action*="/search"]',
    
    suggestion:  'a.gl-focusable-item[href*="/search"], .gl-popular-search-terms a, .gl-popular-search-term-item, .gl-fullscreen-top-clicked a',
    productCard: '.gl-product-card',
    resultsWrap: '.gl-fullscreen-results__content, #gl-search-listbox',
    
    pageResults: '.collection-products-list, #product-grid, [id*="ProductGridContainer"]',
    pageCard:    '.product-card, product-card, .card-wrapper, .grid__item',
    /* The active Header marks its account control explicitly; retain legacy
       customer-authentication and /account paths for compatibility. */
    account:     'shopify-account, [data-header-account-trigger], a.header-icon-link[href*="/customer_authentication"], a[href*="/account"]',
    searchIcon:  '[data-header-search-trigger], button.header-icon-link[aria-label="Buscar"], a.header-icon-link[href*="/search"], header [aria-label="Buscar"], header [aria-label="Search"]',
    cartTrigger: '[data-header-cart-trigger]',
    cartDrawer:  'cart-drawer, [drawer-minicart]'
  };

  function txt(el) { return el && el.innerText ? el.innerText.trim().replace(/\s+/g, ' ').slice(0, 80) : ''; }
  function all(root, sel) { return root ? [].slice.call(root.querySelectorAll(sel)) : []; }

  function base(cfg, extra) {
    var out = {
      page_type: DL.ctx.page_type,
      component_id: cfg.component_id,
      placement: cfg.placement
    };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  
  function navItemId(href) {
    if (!href) return undefined;
    var m = String(href).match(/\/(collections|products|pages|blogs)\/([^/?#]+)/);
    if (m) return m[1].replace(/s$/, '') + ':' + m[2];
    if (/\/apps\//.test(href)) return 'app:' + (String(href).split('/apps/')[1] || '').split(/[/?#]/)[0];
    return undefined;
  }

  var LV_RE = /tmenu_item_level_(\d+)/;

  
  function navLevel(a) {
    var li = a.closest('li.tmenu_item');
    if (li) {
      var m = String(li.className || '').match(LV_RE);
      if (m) return Math.min(3, parseInt(m[1], 10) + 1);
    }
    if (a.closest('ul.mega-menu-item-inner')) return 3;
    if (a.closest('.mega-menu-container, .mega-menu-item')) return 2;
    return 1;
  }

  
  function parentNavId(a) {
    var li = a.closest('li.tmenu_item, li.header-menu-item');
    var up = li && li.parentNode && li.parentNode.closest
      ? li.parentNode.closest('li.tmenu_item, li.header-menu-item') : null;
    var link = up ? up.querySelector(SEL.navRootLink) : null;
    if (!link) {
      var wrap = a.closest('.mega-menu-item-wrapper');
      if (wrap) link = wrap.querySelector('.mega-menu-link-main');
    }
    return navItemId(link && link.getAttribute('href'));
  }

  
  function navName(a) {
    var s = a.querySelector(SEL.navText);
    return txt(s) || txt(a);
  }

  function cartType() {
    return (DL.ctx.cart_type === 'drawer' || DL.ctx.cart_type === 'notification') ? 'drawer' : 'page';
  }

  

  d.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;

    var logo = t.closest(SEL.logo);
    if (logo) {
      DL.afterTick(function () {
        var __np = DL.navPush(evt, logo);
        if (!__np) return;
        __np('logo_click', base(C.logo, { destination_url: logo.getAttribute('href') || undefined }));
      });
      return;
    }

    
    var navA = t.closest(SEL.navLink);
    if (navA && navA.getAttribute('href')) {
      var lv  = navLevel(navA);
      var pid = parentNavId(navA);
      DL.afterTick(function () {
        var __np = DL.navPush(evt, navA);
        if (!__np) return;
        var href = navA.getAttribute('href');
        __np('nav_click', base(C.nav, {
          nav_level: lv,
          nav_item_id: navItemId(href),
          nav_item_name: navName(navA),
          parent_nav_item_id: pid,
          destination_url: href || undefined
        }));
      });
      return;
    }

    var mob = t.closest(SEL.mobileLink);
    if (mob) {
      DL.afterTick(function () {
        var __np = DL.navPush(evt, mob);
        if (!__np) return;
        var href = mob.getAttribute('href');
        __np('nav_click', base(C.nav, {
          nav_level: 1,
          nav_item_id: navItemId(href),
          nav_item_name: txt(mob),
          destination_url: href || undefined
        }));
      });
      return;
    }

    var acc = t.closest(SEL.account);
    
    if (acc && !acc.matches('shopify-account') &&
        !acc.closest('.header-right, [class*="header-"], header, #shopify-section-header')) acc = null;
    if (acc) {
      DL.afterTick(function () {
        if (!DL.isInteractive(acc)) return;
        DL.push('account_entry_click', base(C.account, {
          destination_url: (acc.getAttribute && acc.getAttribute('href')) || undefined,
          login_state: DL.ctx.customer_logged_in ? 'logged_in' : 'guest'
        }));
      });
      return;
    }

    var cartBtn = t.closest(SEL.cartTrigger);
    if (cartBtn) {
      DL.afterTick(function () {
        if (!DL.isInteractive(cartBtn)) return;
        DL.push('cart_entry_click', base(C.cart, { cart_type: cartType() }));
      });
    }
  }, true);

  /* ============ H1-02 nav_menu_open ============ */
  

  function initNavMenuOpen() {
    var opened = {};

    
    function panelOpen(item) {
      
      if (item.classList.contains('open') || item.classList.contains('tmenu_item_active')) return true;
      var p = item.querySelector(SEL.navSubmenu);
      if (!p || p.hasAttribute('hidden')) return false;
      var cs = w.getComputedStyle(p);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      if (parseFloat(cs.opacity || '1') < 0.1) return false;
      var r = p.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    function emit(item, method) {
      var link = item.querySelector(SEL.navRootLink);
      var key = navItemId(link && link.getAttribute('href')) || (link ? navName(link) : '');
      if (!key || opened[key]) return;
      opened[key] = 1;
      DL.push('nav_menu_open', base(C.nav, {
        nav_level: 1,
        nav_item_id: navItemId(link && link.getAttribute('href')),
        nav_item_name: link ? navName(link) : undefined,
        interaction_method: method
      }));
    }

    
    var hoverItem = null, hoverTimer = null;

    d.addEventListener('mouseover', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var item = t.closest(SEL.navItem);
      if (!item || item === hoverItem) return;
      if (!item.querySelector(SEL.navSubmenu)) return;
      hoverItem = item;
      if (hoverTimer) w.clearTimeout(hoverTimer);
      
      var waited = 0;
      hoverTimer = w.setTimeout(function poll() {
        if (hoverItem !== item) return;
        if (panelOpen(item)) { emit(item, 'hover'); return; }
        waited += 100;
        if (waited > 1200) return;
        hoverTimer = w.setTimeout(poll, 100);
      }, 300);
    }, true);

    d.addEventListener('mouseout', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var item = t.closest(SEL.navItem);
      if (!item || item !== hoverItem) return;
      
      var to = evt.relatedTarget;
      if (to && to.closest && to.closest(SEL.navItem) === item) return;
      hoverItem = null;
      if (hoverTimer) { w.clearTimeout(hoverTimer); hoverTimer = null; }
    }, true);

    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var item = t.closest(SEL.navItem);
      if (!item || !item.querySelector(SEL.navSubmenu)) return;
      w.setTimeout(function () { if (panelOpen(item)) emit(item, 'click'); }, 120);
    }, true);
  }

  

  var searchState = { queryId: null, term: '', method: null, reported: {} };
  var batchIndex = 0;

  var QID_KEY = 'dji_search_qid';

  function newQueryId() {
    searchState.queryId = DL.uuid();
    searchState.reported = {};
    return searchState.queryId;
  }

  
  function stashQueryId(term, method) {
    try {
      w.sessionStorage.setItem(QID_KEY, JSON.stringify({
        qid: searchState.queryId, term: String(term || ''),
        
        method: method || searchState.method || null,
        at: Date.now()
      }));
    } catch (e) {}
  }

  function adoptQueryId(term) {
    var rec = null;
    try { rec = JSON.parse(w.sessionStorage.getItem(QID_KEY) || 'null'); } catch (e) {}
    if (!rec || !rec.qid) return null;
    if (Date.now() - (rec.at || 0) > 120000) return null;
    if (String(rec.term || '') !== String(term || '')) return null;   
    searchState.queryId = rec.qid;
    return rec.qid;
  }

  function clearStashedQueryId() {
    try { w.sessionStorage.removeItem(QID_KEY); } catch (e) {}
  }

  function popup() {
    var p = d.querySelector(SEL.searchPopup);
    if (!p) return null;
    var r = p.getBoundingClientRect(), s = w.getComputedStyle(p);
    if (s.display === 'none' || s.visibility === 'hidden' || r.height === 0) return null;
    return p;
  }

  function currentTerm() {
    var i = d.querySelector(SEL.searchInput) || d.querySelector(SEL.searchPopup + ' input[name="q"]');
    return i ? String(i.value || '').trim() : '';
  }

  function resultCards(p) { return all(p || d, SEL.productCard); }

  function resultsCount(p) {
    var meta = (p || d).querySelector('.gl-fullscreen-results__meta, [data-total-results]');
    if (meta) {
      var attr = meta.getAttribute && meta.getAttribute('data-total-results');
      if (attr && !isNaN(attr)) return Number(attr);
      var m = String(meta.innerText || '').replace(/[.,]/g, '').match(/(\d+)/);
      if (m) return Number(m[1]);
    }
    return resultCards(p).length;
  }

  function searchItem(card, index) {
    var link = card.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : '';
    var title = txt(card.querySelector('[class*="title"]')) ||
      String((link && link.getAttribute('aria-label')) || '').replace(/^[^:]*:\s*/, '').slice(0, 80);
    return DL.clean({
      item_id: card.getAttribute('data-product-id') ||
               ((card.querySelector('[data-product-id]') || {}).getAttribute
                 ? card.querySelector('[data-product-id]').getAttribute('data-product-id') : undefined),
      item_name: title || undefined,
      item_brand: DL.ctx.brand || 'DJI',
      product_handle: (String(href).match(/\/products\/([^/?#]+)/) || [])[1],
      quantity: 1,
      item_list_id: 'search_results',
      item_list_name: 'Search Results',
      index: index
    });
  }

  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;
  var resultsTimer = null;

  function watchResults(p) {
    if (!p) return;
    if (watched) { if (watched.has(p)) return; watched.add(p); }
    var mo = new MutationObserver(function () {
      if (resultsTimer) w.clearTimeout(resultsTimer);
      resultsTimer = w.setTimeout(function () { evaluateResults(p); }, 600);
    });
    mo.observe(p, { childList: true, subtree: true, characterData: true });
  }

  function evaluateResults(p) {
    if (!popup()) return;
    var term = currentTerm();
    if (!term || term.length < 2) return;
    var safe = DL.sanitize(term);
    if (!safe) return;

    if (safe !== searchState.term) {
      searchState.term = safe;
      newQueryId();
      batchIndex = 0;
    }
    var qid = searchState.queryId;
    var count = resultsCount(p);

    
    if (!searchState.reported.view) {
      searchState.reported.view = 1;
      DL.push('view_search_results', base(C.results, {
        query_id: qid,
        search_term_sanitized: safe,
        results_count: count,
        current_filters: '',
        current_sort: ''
      }));
    }

    
    if (count === 0) {
      if (!searchState.reported.none) {
        searchState.reported.none = 1;
        DL.push('search_no_results', base(C.results, {
          query_id: qid,
          search_term_sanitized: safe,
          search_method: searchState.method || 'enter',
          results_count: 0
        }));
      }
      return;
    }

    
    var wrap = p.querySelector(SEL.resultsWrap);
    if (!wrap || !resultCards(p).length) return;
    batchIndex += 1;
    var thisBatch = batchIndex;
    DL.observe(wrap, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
      if (!DL.once('view_item_list|search|' + qid + '|' + thisBatch)) return;
      
      var items = resultCards(p).map(function (c, i) { return searchItem(c, i + 1); });
      if (!items.length) return;
      DL.push('view_item_list', base(C.resultGrid, {
        item_list_id: 'search_results',
        item_list_name: 'Search Results',
        query_id: qid,
        list_batch_index: thisBatch,
        current_filters: '',
        current_sort: '',
        exposure_rule: meta && meta.rule,
        items: items
      }));
    });
  }

  
  d.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    var p = t.closest(SEL.searchPopup);
    if (!p) return;

    var card = t.closest(SEL.productCard);
    if (card) {
      var cards = resultCards(p);
      var idx = cards.indexOf(card);
      var link = t.closest('a[href]') || card.querySelector('a[href]');
      var item = searchItem(card, idx > -1 ? idx + 1 : undefined);
      var isZeroState = !currentTerm();
      DL.afterTick(function () {
        
        var __np = link ? DL.navPush(evt, link) : DL.push;
        if (!__np) return;
        if (isZeroState) {
          __np('search_select_item', base(C.suggestPd, {
            item_list_id: 'search_suggestions_zero',
            item_list_name: 'Search Zero-state Suggestions',
            index: idx > -1 ? idx + 1 : undefined,
            items: [item]
          }));
        } else {
          __np('select_item', base(C.resultGrid, {
            item_list_id: 'search_results',
            item_list_name: 'Search Results',
            query_id: searchState.queryId,
            index: idx > -1 ? idx + 1 : undefined,
            destination_url: link ? link.getAttribute('href') : undefined,
            items: [item]
          }));
        }
      });
      return;
    }

    var sug = t.closest(SEL.suggestion);
    if (sug) {
      var href = sug.getAttribute('href') || '';
      var qm = href.match(/[?&]q=([^&]*)/);
      var word = qm ? decodeURIComponent(qm[1].replace(/\+/g, ' ')) : txt(sug);
      var sugs = all(p, SEL.suggestion);
      var sIdx = sugs.indexOf(sug);
      searchState.method = 'keyword_suggestion';
      
      if (!searchState.queryId) newQueryId();
      stashQueryId(currentTerm() || txt(sug), 'keyword_suggestion');
      DL.afterTick(function () {
        var __np = DL.navPush(evt, sug);
        if (!__np) return;
        __np('search_suggestion_click', base(C.suggest, {
          suggestion_type: 'keyword',
          suggestion_id: DL.sanitize(word),
          suggestion_text: DL.sanitize(word),
          suggestion_index: sIdx > -1 ? sIdx + 1 : undefined,
          search_method: 'keyword_suggestion'
        }));
      });
    }
  }, true);

  /* H1-04 site_search_open */
  function initSearchOpen() {
    var isOpen = false;
    var mo = new MutationObserver(function () {
      var p = popup();
      if (p && !isOpen) {
        isOpen = true;
        newQueryId();
        clearSearchOpenIntent();   
        DL.push('site_search_open', base(C.search, { search_surface: 'drawer' }));
      } else if (!p && isOpen) {
        isOpen = false;
      }
      if (p) watchResults(p);
    });
    mo.observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

    
    if (DL.ctx.page_type === 'search' && DL.ctx.search && consumeSearchOpenIntent()) {
      newQueryId();
      if (DL.onceSession('site_search_open|' + (searchState.queryId || ''))) {
        DL.push('site_search_open', base(C.search, { search_surface: 'page' }));
      }
    }
  }

  
  var OPEN_KEY = 'dji_search_open_intent';

  function markSearchOpenIntent() {
    try { w.sessionStorage.setItem(OPEN_KEY, String(DL.now ? DL.now() : +new Date())); } catch (e) {}
  }

  function clearSearchOpenIntent() {
    try { w.sessionStorage.removeItem(OPEN_KEY); } catch (e) {}
  }

  
  function consumeSearchOpenIntent() {
    var v = null;
    try { v = w.sessionStorage.getItem(OPEN_KEY); } catch (e) {}
    clearSearchOpenIntent();
    if (!v) return false;
    var t = parseInt(v, 10);
    if (!t) return false;
    return (+new Date()) - t < 10000;
  }

  d.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    if (!t.closest(SEL.searchIcon)) return;
    markSearchOpenIntent();
  }, true);

  /* S3 search_submit */
  function initSearchSubmit() {
    
    d.addEventListener('submit', function (evt) {
      var form = evt.target;
      if (!form || !form.matches || !form.matches(SEL.searchForm)) return;
      var input = form.querySelector('input[name="q"]');
      var term = input ? String(input.value || '').trim() : '';
      if (!term) return;
      if (!searchState.queryId) newQueryId();
      
      var m = searchState.method;
      if (!m) {
        var sb = evt.submitter || d.activeElement;
        m = (sb && sb.matches && sb.matches('button, [type="submit"], [role="button"]')) ? 'button' : 'enter';
      }
      searchState.method = m;
      stashQueryId(term, m);
    }, true);

    
    var meta = DL.ctx.search;
    if (!meta || !meta.term) return;

    var term = String(meta.term);

    
    var stashed = null;
    try { stashed = JSON.parse(w.sessionStorage.getItem(QID_KEY) || 'null'); } catch (e) {}
    var qid = adoptQueryId(term) || newQueryId();
    clearStashedQueryId();
    if (!DL.onceSession('search_submit|' + qid)) return;
    var safe = DL.sanitize(term);
    var method = searchState.method ||
                 (stashed && stashed.term === term ? stashed.method : null) || 'enter';

    
    function emitSearchTrio(count) {
      DL.push('search_submit', base(C.siteSearch, {
        search_method: method,
        search_term_sanitized: safe,
        results_count: count,
        query_id: qid
      }));
      DL.push('view_search_results', base(C.results, {
        query_id: qid,
        search_term_sanitized: safe,
        results_count: count,
        current_filters: '',
        current_sort: ''
      }));
      if (count === 0) {
        DL.push('search_no_results', base(C.results, {
          query_id: qid,
          search_term_sanitized: safe,
          search_method: method,
          results_count: 0
        }));
      }
    }

    var raw = meta.results_count;
    if (raw !== null && raw !== undefined && raw !== '' && !isNaN(Number(raw))) {
      emitSearchTrio(Number(raw));
      return;
    }

    
    var last = -1, same = 0, waited = 0;
    (function settle() {
      var n = pageResultCards().length;
      if (n === last) same += 1; else { same = 0; last = n; }
      waited += 500;
      if (same >= 2 || waited >= 8000) { emitSearchTrio(last < 0 ? 0 : last); return; }
      w.setTimeout(settle, 500);
    })();
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function pageResultCards() {
    var wrap = d.querySelector(SEL.pageResults);
    if (!wrap) return [];
    return all(wrap, SEL.pageCard).filter(function (c) {
      return c.querySelector('a[href*="/products/"]');
    });
  }

  function pageCardItem(card, index) {
    var link = card.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : '';
    var handle = (String(href).match(/\/products\/([^/?#]+)/) || [])[1] || '';
    
    var pid = (card.getAttribute && card.getAttribute('data-product-id')) || '';
    if (!pid) {
      var idEl = card.querySelector('[data-product-id]');
      pid = idEl ? idEl.getAttribute('data-product-id') : '';
    }
    
    if (!pid) return null;
    return DL.item(pid, {
      index: index,
      item_list_id: 'search_results',
      item_list_name: 'Search Results',
      item_name: txt(card.querySelector('[class*="title"], h3, h2')) || undefined
    });
  }

  function initSearchResultsPage() {
    if (DL.ctx.page_type !== 'search') return;
    if (!d.querySelector(SEL.pageResults)) return;

    
    function wrapNow() { return d.querySelector(SEL.pageResults); }

    
    var pageBatch = 0;
    var stopPageObserve = null;

    function observeBatch(trigger) {
      var wrap = wrapNow();
      if (!wrap) return;
      var list = pageResultCards();
      if (!list.length) return;
      pageBatch += 1;
      var thisBatch = pageBatch;
      if (stopPageObserve) { try { stopPageObserve(); } catch (e) {} stopPageObserve = null; }
      stopPageObserve = DL.observe(wrap, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
        var now = pageResultCards();
        if (!now.length) return;
        if (!DL.once('view_item_list|search_results|' + thisBatch)) return;
        var items = now.map(function (c, i) { return pageCardItem(c, i + 1); }).filter(Boolean);
        if (!items.length) return;
        DL.push('view_item_list', base(C.resultGrid, {
          item_list_id: 'search_results',
          item_list_name: 'Search Results',
          query_id: searchState.queryId,
          list_batch_index: thisBatch,
          trigger_source: trigger,
          current_filters: '',
          current_sort: '',
          exposure_rule: meta.rule,
          exposure_ratio: meta.ratio_observed,
          items: items
        }));
      });
    }

    observeBatch('initial');

    
    (function watchPageResults() {
      var sig = pageResultCards().length;
      var settle = null;
      try {
        new MutationObserver(function () {
          if (settle) w.clearTimeout(settle);
          settle = w.setTimeout(function () {
            var now = pageResultCards().length;
            if (now === sig || !now) return;
            var grew = now > sig;
            sig = now;
            observeBatch(grew ? 'load_more' : 'filter');
          }, 400);
        }).observe(d.body, { childList: true, subtree: true });
      } catch (e) {}
    })();

    
    d.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var card = t.closest(SEL.pageCard);
      if (!card || !card.closest(SEL.pageResults)) return;   
      
      var link = t.closest('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href');
      var pos = pageResultCards().indexOf(card);
      var index = pos > -1 ? pos + 1 : undefined;
      DL.afterTick(function () {
        var __np = DL.navPush(evt, link);
        if (!__np) return;
        var item = pageCardItem(card, index);
        if (!item) return;
        __np('select_item', base(C.resultGrid, {
          item_list_id: 'search_results',
          item_list_name: 'Search Results',
          query_id: searchState.queryId,
          index: index,
          destination_url: href,
          items: [item]
        }));
      });
    }, true);
  }

  /* H1-07 view_cart */
  function initViewCart() {
    var drawer = d.querySelector(SEL.cartDrawer);
    if (!drawer) return;
    var opened = drawer.hasAttribute('drawer-open');
    var mo = new MutationObserver(function () {
      var isOpen = drawer.hasAttribute('drawer-open') || drawer.classList.contains('drawer-open');
      if (isOpen && !opened) {
        opened = true;
        w.setTimeout(function () {
          DL.fetchCart().then(function (cart) {
            if (!cart) return;
            DL.push('view_cart', base(C.cart, {
              cart_type: cartType(),
              item_count: cart.item_count,
              value: DL.money(cart.total_price),
              items: DL.itemsFromCartLines(cart.items, {
                item_list_id: 'cart_drawer',
                item_list_name: 'Cart Drawer'
              })
            }));
          });
        }, 150);
      } else if (!isOpen) {
        opened = false;
      }
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['drawer-open', 'class'] });
  }

  /* H1-08 begin_checkout desde el carrito (página /cart + cajón lateral).
     El PDP ya emite begin_checkout desde el área de compra / sticky / pago dinámico; aquí cubrimos
     los DEMÁS puntos de "ir a pagar": el botón "Finalizar compra" de /cart y el enlace de checkout
     del cajón. Se mantiene el carrito en caché (carga + cart:updated) para poder enviar el evento de
     forma SÍNCRONA antes de que el clic navegue a /checkout (igual criterio que begin_checkout del PDP). */
  function initCartCheckout() {
    var cartCache = null;
    function refresh() { try { DL.fetchCart().then(function (c) { if (c && c.items) cartCache = c; }); } catch (e) {} }
    refresh();
    d.addEventListener('cart:updated', function (e) {
      if (e && e.detail && e.detail.cartData && e.detail.cartData.items) cartCache = e.detail.cartData;
      else refresh();
    });
    var lastSent = 0;
    d.addEventListener('click', function (e) {
      var t = e.target;
      var btn = t.closest && t.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"], a[href*="/cart/checkout"]');
      if (!btn) return;
      /* Excluir lo que YA cubre el tracking del PDP: pago dinámico (Shop Pay) y el área de compra
         principal / sticky del producto (allí begin_checkout se emite con su propio contexto). */
      if (btn.closest('.shopify-payment-button, product-info, [id^="MainProduct"], .dji-sticky-atc, [class*="sticky-atc"]')) return;
      if (Date.now() - lastSent < 2000) return;             /* anti doble clic */
      lastSent = Date.now();
      var inDrawer = !!(btn.closest && btn.closest(SEL.cartDrawer));
      var cfg = inDrawer
        ? { component_id: 'cart_drawer_checkout', placement: 'cart_drawer' }
        : { component_id: 'cart_page_checkout', placement: 'cart' };
      DL.afterTick(function () {
        if (!DL.isInteractive(btn)) return;
        var extra = { element_id: 'begin_checkout', checkout_method: 'standard', cart_type: inDrawer ? 'drawer' : 'page' };
        var cart = cartCache;
        if (cart && cart.items) {
          extra.item_count = cart.item_count;
          extra.value = DL.money(cart.total_price);
          extra.items = DL.itemsFromCartLines(cart.items, { item_list_id: 'cart', item_list_name: 'Cart' });
        }
        DL.push('begin_checkout', base(cfg, extra));
      });
    }, true);
  }

  /* H1-09 · Barra de anuncios (app de terceros <single-banner> con shadow DOM).
     No es un <a>; la app navega por JS al hacer clic (p. ej. a la página de campaña). Rastreamos
     view_promotion (cuando la barra se ve) y select_promotion (clic). El evento de clic es compuesto,
     así que a nivel document e.target queda re-apuntado al host <single-banner>. Como no hay href,
     no se usa navPush: se envía de inmediato en afterTick, antes de que la app navegue. */
  function initAnnouncementBar() {
    var CFG = { component_id: 'announcement_bar', placement: 'announcement_bar' };
    var SEL_BAR = 'single-banner, [bss-banner], [banner_id]';
    function host() { return d.querySelector(SEL_BAR); }
    function promoId(h) { var id = h && h.getAttribute('banner_id'); return id ? 'announcement_bar_' + id : 'announcement_bar'; }
    function promoName(h) {
      /* el texto vive en shadow DOM anidado; se recorre hasta .banner-content-wrapper */
      try {
        function find(node, depth) {
          if (!node || depth > 6) return '';
          var sr = node.shadowRoot;
          if (sr) {
            var cw = sr.querySelector('.banner-content-wrapper, [class*="content-wrapper"]');
            if (cw && (cw.innerText || '').trim()) return cw.innerText.replace(/\s+/g, ' ').trim().slice(0, 120);
            var inner = [].slice.call(sr.querySelectorAll('*')).filter(function (x) { return x.shadowRoot; });
            for (var i = 0; i < inner.length; i++) { var r = find(inner[i], depth + 1); if (r) return r; }
          }
          return '';
        }
        return find(h, 0);
      } catch (e) { return ''; }
    }

    /* view_promotion: la barra la inyecta la app de forma asíncrona → sondeo hasta ~12s. */
    var tries = 0;
    (function pollView() {
      var h = host();
      if (h) {
        if (DL.once('view_promotion|' + promoId(h))) {
          DL.push('view_promotion', base(CFG, {
            promotion_id: promoId(h),
            promotion_name: promoName(h) || undefined,
            creative_slot: 'announcement_bar'
          }));
        }
        return;
      }
      if (++tries < 40) w.setTimeout(pollView, 300);
    })();

    /* select_promotion: clic en la barra. Delegado en document (captura) para no depender del shadow. */
    d.addEventListener('click', function (e) {
      var h = e.target && e.target.closest && e.target.closest(SEL_BAR);
      if (!h) return;
      DL.afterTick(function () {
        DL.push('select_promotion', base(CFG, {
          promotion_id: promoId(h),
          promotion_name: promoName(h) || undefined,
          element_id: 'announcement_bar',
          creative_slot: 'announcement_bar'
        }));
      });
    }, true);
  }

  function start() {
    initNavMenuOpen();
    initSearchOpen();
    initSearchSubmit();
    initSearchResultsPage();
    initViewCart();
    initCartCheckout();
    initAnnouncementBar();
    var p = popup();
    if (p) watchResults(p);
    DL.log('header tracking ready', DL.ctx.page_type);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})(window, document);
